<div class="production-modal">
    <div class="close-modal">
        <img
            appImageSelector
            alt="mt-image"
            imageType="icon"
            imageKey="close-gray"
            alt="close-icon"
            (click)="activeModal.close()"
        />
    </div>

    <div class="header">
        <div class="title">
            {{ title }}
        </div>
        <div class="subtitle">{{ shiftTitle }} - {{ date }}</div>
    </div>

    <div class="mat-tabs">
        <mat-tab-group (selectedTabChange)="changeTab($event)">
            <mat-tab [label]="'summary-production' | lang">
                <app-summary-production
                    [data]="summaryData"
                    [machineObjCode]="machineObjCode"
                ></app-summary-production>
            </mat-tab>

            <mat-tab [label]="translateTab">
                <app-shift-loops-production
                    [data]="shiftLoopsData"
                    [machineObjCode]="machineObjCode"
                ></app-shift-loops-production>
            </mat-tab>
            <!-- <mat-tab [label]="'drilling-loop'| lang" *ngIf="machineObjCode === 'JMB'">
                <app-shift-loops-production [data]="shiftLoopsData" [machineObjCode]="machineObjCode"></app-shift-loops-production>
            </mat-tab> -->

            <mat-tab [label]="'statistics' | lang">
                <app-statistics-production
                    [data]="statisticsProductionData"
                    [machineObjCode]="machineObjCode"
                >
                </app-statistics-production>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
